<!-- I need to make sure my changes aren't breaking other pages that use this component -->
<mat-expansion-panel
  (opened)="togglePanel(true)"
  (closed)="togglePanel(false)"
  [expanded]="!collapseContent"
  [hideToggle]="showArrow"
  class="expandable-panel-container"
  data-cy="expandable-panel"
  [ngClass]="{
    'hide-borders': hideBorders,
    'update-header': !!stylesObject['updateHeader']
  }"
>
  <mat-expansion-panel-header
    [ngClass]="{
      'fixed-content': fixedContent,
      'add-border-bottom': addBottomBorder
    }"
    *ngIf="displayHeader"
  >
    <ng-content select="[header]"></ng-content>
    <h2 *ngIf="!!title" data-cy="expandable-panel-title">{{ title }}</h2>
    <ion-icon
      *ngIf="showArrow"
      data-cy="expandable-panel-arrow"
      name="{{
        arrowDirection ? 'chevron-up-outline' : 'chevron-down-outline'
      }}"
      class="arrow"
    ></ion-icon>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
